module.exports = __webpack_public_path__ + "img/gd-b.bf70e445.png";